import React, { FC } from "react";

export interface TimelineStepProps {
  step: React.ReactNode;
  duration: string;
  title: string;
  description: string;
  isLast?: boolean;
}

export const TimelineStep: FC<TimelineStepProps> = ({ step, duration, title, description, isLast = false }) => {
  return (
    <div className="relative flex items-start gap-4 pb-8">
      <div className="flex flex-col items-center">
        <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white border-2 border-primary text-primary font-bold text-lg shadow-lg">
          {step}
        </div>
        {!isLast && (
          <div className="mt-2 h-16 w-0.5 bg-gradient-to-b from-primary to-gray-200/30" />
        )}
      </div>
      <div className="flex-1 space-y-2 pt-1">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center rounded-full bg-primary px-3 py-1 text-sm font-medium text-white">
            {duration}
          </span>
        </div>
        <h3 className="text-lg text-left font-semibold text-black">{title}</h3>
        <p className="text-sm text-left text-gray-500 leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
}; 
